import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'cambodia_which_of_the_following_other_wage_payments_were_not_in'

export const dataPointDefinition = {
  retracedId: 'cambodia_which_of_the_following_other_wage_payments_were_not_in',
  name: 'Cambodia: Which of the following OTHER wage payments were not in line with legal requirements? (SELECT all that apply with an "X")',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CAMBODIA_TRANSPORT_HOME_OR_A_PLACE_TO_SLEEP_FOR_WORKERS_WHO_FIN',
      text: 'Cambodia: Transport home or a place to sleep for workers who finish work between 22:00 and 05:00',
      externalIds: [
        {
          id: 'wb-wag-128x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CAMBODIA_WAGE_SUPPLEMENTS_INCLUDING_TRANSPORTATION_AND_HOUSING_',
      text: 'Cambodia: Wage supplements (including transportation and housing allowances)',
      externalIds: [
        {
          id: 'wb-wag-129x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CAMBODIA_ATTENDANCE_BONUS_DURING_LEAVE',
      text: 'Cambodia: Attendance bonus during leave',
      externalIds: [
        {
          id: 'wb-wag-130x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CAMBODIA_ATTENDANCE_BONUS_TO_NEW_WORKERS',
      text: 'Cambodia: Attendance bonus to new workers',
      externalIds: [
        {
          id: 'wb-wag-131x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CAMBODIA_ATTENDANCE_BONUS_TO_CASUAL_WORKERS',
      text: 'Cambodia: Attendance bonus to casual workers',
      externalIds: [
        {
          id: 'wb-wag-132x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CAMBODIA_SENIORITY_INDEMNITY_FOR_UNDETERMINED_DURATION_CONTRACT',
      text: 'Cambodia: Seniority indemnity for Undetermined Duration Contract (UDC) workers',
      externalIds: [
        {
          id: 'wb-wag-133x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HAVE_THERE_BEEN_ANY_CASES_OF_HARASSMENT_BASED_UPON_RACE_ETHNIC_',
      text: 'Have there been any cases of harassment based upon race, ethnic group, skin color, religion, political opinion, national extraction, social origin, disability, HIV/AIDS status, sexual orientation, gender identity, pregnancy/maternity status, marital status, family responsibilities, age, nationality/foreign migrant worker status?',
      externalIds: [
        {
          id: 'hb-5',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'NUMBER',
        text: 'If yes, in how many cases was the victim a male worker?',
        externalIds: [
          {
            id: 'wt-har-5',
            version: '1.5.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CAMBODIA_TRANSPORT_HOME_OR_A_PLACE_TO_SLEEP_FOR_WORKERS_WHO_FIN',
                'CAMBODIA_WAGE_SUPPLEMENTS_INCLUDING_TRANSPORTATION_AND_HOUSING_',
                'CAMBODIA_ATTENDANCE_BONUS_DURING_LEAVE',
                'CAMBODIA_ATTENDANCE_BONUS_TO_NEW_WORKERS',
                'CAMBODIA_ATTENDANCE_BONUS_TO_CASUAL_WORKERS',
                'CAMBODIA_SENIORITY_INDEMNITY_FOR_UNDETERMINED_DURATION_CONTRACT',
                'HAVE_THERE_BEEN_ANY_CASES_OF_HARASSMENT_BASED_UPON_RACE_ETHNIC_',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-127',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9800,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
